<template>
    <div v-if="'on' in node" class="state-node">
        <div v-if="0" class="state-node__label" v-text="label" />
        <div v-if="0" class="state-node__label">
            <button @click="refreshNode">refresh</button>
        </div>
        <div class="state-node__container">
            <div class="state-node__tree-container">
                <NodesTree
                    ref="nodesTreeRes"
                    :nodes="actionsTree"
                    :allowed-actions="allowedActions"
                    @addNode="addAction"
                    @updateNode="updateAction"
                    @deleteNode="deleteAction"
                    @updateNodeTree="updateActions"
                    @deleteRelations="deleteRelations"
                />
            </div>
            <div class="state-node__relations" :style="{ ...relationsStyle }">
                <svg xmlns="http://www.w3.org/2000/svg">
                    <defs>
                        <marker
                            id="arrowhead"
                            markerWidth="10"
                            markerHeight="7"
                            refX="10"
                            refY="3.5"
                            orient="auto"
                        >
                            <polygon points="0 0, 10 3.5, 0 7" />
                        </marker>
                    </defs>
                    <line
                        v-for="(relation, i) in relationsItems"
                        :key="`relation-${i}`"
                        :x1="relation.x1"
                        :y1="relation.y1"
                        :x2="relation.x2"
                        :y2="relation.y2"
                        stroke="#777"
                        stroke-width="1"
                        marker-end="url(#arrowhead)"
                    />
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
import NodesTree from './NodesTree';

export default {
    name: 'StateNode',
    components: {
        NodesTree,
    },
    props: {
        node: {
            type: Object,
            required: true,
        },
        actions: {
            type: Array,
            default: () => [],
        },
        allowedActions: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            relationsItems: [],
            relationsStyle: {},
        };
    },
    computed: {
        label() {
            const { locale } = this.$i18n;
            const { [locale]: label } = this.node.label;
            return label;
        },
        actionsTree() {
            return this.makeTree();
        },
    },
    watch: {
        actions: {
            immediate: true,
            deep: true,
            async handler(actions) {
                await this.$nextTick();
                if (!actions.length) return;
                this.refreshNode();
            },
        },
    },
    mounted() {
        // 'on' in this.node && !this.actions.length && this.$emit('addAction');
    },
    methods: {
        addAction(event) {
            this.$emit('addAction', event);
        },
        updateAction(event) {
            this.$emit('updateAction', event);
        },
        deleteAction(event) {
            this.$emit('deleteAction', event);
        },
        updateActions(event) {
            this.$emit('updateActions', event);
        },
        deleteRelations(event) {
            console.log('deleteRelations', event);
            this.$emit('deleteRelations', event);
        },
        makeTree(pid = null, filter = [], level = 0) {
            if (!Array.isArray(this.actions) || !this.actions.length) return [];

            const filtered = this.actions.filter(({ id, depends_on = [] }) => {
                if (!pid) return !depends_on.length;
                if (filter.length && !filter.includes(id)) return false;

                return depends_on.slice().shift() === pid;
            });

            if (!filtered.length) return [];
            level += +!!pid;

            return filtered.map(
                ({
                    id,
                    action = null,
                    depends_on = [],
                    start = [],
                    editable = false,
                    created = false,
                }) => ({
                    id,
                    action,
                    label: this.getActionLabel(action),
                    childs: this.makeTree(id, start, level),
                    depends_on,
                    start,
                    level,
                    editable,
                    created,
                })
            );
        },
        getActionLabel(action) {
            const { label = action } = this.allowedActions.find((a) => a.action === action) || {};
            return label;
        },
        async refreshNode() {
            await this.$nextTick();

            const cont = document.querySelector('.state-node__container');
            const contRect = cont.getBoundingClientRect();
            const wrapCont = cont.querySelector('.nodes-tree');
            const relations = [];

            cont.scrollTop = 0;
            cont.scrollLeft = 0;

            this.actions.forEach(async (action) => {
                await this.$nextTick();

                const { start = [] } = action;
                const parentEl = document.querySelector(
                    `[data-node-id="${action.id}"] .nodes-tree-item__content`
                );
                const parentRect = parentEl ? parentEl.getBoundingClientRect() : {};

                if (start.length) {
                    start.forEach(async (id) => {
                        await this.$nextTick();

                        const { created = false } = this.actions.find((a) => a.id === id);
                        const childRect = document
                            .querySelector(`[data-node-id="${id}"] .nodes-tree-item__content`)
                            .getBoundingClientRect();

                        const { x = 0, y = 0, width = 0, height = 0 } = parentRect;
                        const x1 = x - contRect.x + width / 2;
                        const x2 = childRect.x - contRect.x + childRect.width / 2;
                        const y1 = y - contRect.y + height;
                        const y2 = childRect.y - contRect.y - 10;

                        if (!created) {
                            relations.push({ x1, x2, y1, y2 });
                        }
                    });
                }
            });

            this.relationsItems = relations;

            await this.$nextTick();

            this.relationsStyle = {
                width: `${wrapCont.getBoundingClientRect().width}px`,
                height: `${wrapCont.getBoundingClientRect().height}px`,
            };
        },
    },
};
</script>
